<template lang="pug">
    filter-mobile
        form.c-form.inverse

            // Sort by Full Name
            v-select(
                name="fullName"
                v-if="isChampion"
                append-icon="expand_more"
                outline
                v-model="model.sort.name"
                @change="e => sortHandler('fullName', e)"
                :items="$t('selection.sort')"
                :label="$t('business.mobile.sort.date')"
            )

            // Filter by Status
            v-select(
                name="status"
                append-icon="expand_more"
                outline
                @change="e => filterHandler({ name: 'isActive', value: e})"
                :items="$t('business.mobile.filter.status.filter')"
                :label="$t('business.mobile.filter.status.name')"
            )

            div(v-if="filters && Object.keys(filters).length")
                div(v-for="(filter, key) in filters" :key="key")

                    // Custom filters
                    v-select(
                        v-if="filter && filter.length >= 1"
                        :name="key"
                        append-icon="expand_more"
                        outline
                        @change="e => filterHandler({ name: $t(`users.mobile.filter.${key}.value`), value: e})"
                        :items="filterItems(filter)"
                        :label="$t($t(`users.mobile.filter.${key}.name`))"
                    )

                    div {{ $t(`users.mobile.filter.${key}.name`) }}
</template>

<script>
    import VueTypes from 'vue-types';
    import FilterMobile from '~components/FilterMobile';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            FilterMobile
        },
        props: {
            filters: VueTypes.object.def({}),
            sortHandler: VueTypes.func.def(() => {}),
            filterHandler: VueTypes.func.def(() => {})
        },
        data() {
            return {
                model: {
                    sort: {
                        name: null,
                        email: null
                    }
                }
            };
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin'])
        },
        watch: {
            ['model.sort.name'](val) {
                if (val !== null && this.model.sort.email !== null) {
                    this.model.sort.email = null;
                }
            },
            ['model.sort.email'](val) {
                if (val !== null && this.model.sort.name !== null) {
                    this.model.sort.name = null;
                }
            }
        },
        methods: {
            /**
             * Items for filter
             */
            filterItems(filter) {
                if (typeof filter === 'object') return filter;

                const customFilters = this.filters[filter].map(item => {
                    return { title: item, value: item };
                });

                return [
                    {
                        title: 'All',
                        value: null
                    },
                    ...customFilters
                ];
            }
        }
    };
</script>
